
import { dimentionValidator, ipValidator, maxNoBatteryConnectionPowerValidator, modelNoValidator, powerValidator, priceValidator, weightValidator } from "components/Validators/Validators";
import { useState } from "react";



const touchErrors = errors => {
    return Object.entries(errors).reduce((acc, [field, fieldError]) => {
        acc[field] = {
            ...fieldError,
            dirty: true,
        };
        return acc;
    }, {});
};

export const useAddBatteryValidator = form => {
    const [errors, setErrors] = useState({
        modelNo: {
            dirty: false,
            error: false,
            message: "",
        },
        price: {
            dirty: false,
            error: false,
            message: "",
        },
        maxNoBatteryConnection: {
            dirty: false,
            error: false,
            message: "",
        },
        ip: {
            dirty: false,
            error: false,
            message: "",
        },
        power: {
            dirty: false,
            error: false,
            message: "",
        },

        weight: {
            dirty: false,
            error: false,
            message: "",
        },
        dimentions: {
            dirty: false,
            error: false,
            message: "",
        },

    });

    const validateForm = ({ form, field, errors, forceTouchErrors = false }) => {
        let isValid = true;

        // Create a deep copy of the errors
        let nextErrors = JSON.parse(JSON.stringify(errors));

        // Force validate all the fields
        if (forceTouchErrors) {
            nextErrors = touchErrors(errors);
        }

        const { modelNo = '', maxNoBatteryConnection = '', ip = '', price = '', power = '', weight = '', dimentions = '' } = form;

        if (nextErrors.modelNo.dirty && (field ? field === "modelNo" : true)) {
            const modelNoMessage = modelNoValidator(modelNo, form);
            nextErrors.modelNo.error = !!modelNoMessage;
            nextErrors.modelNo.message = modelNoMessage;
            if (!!modelNoMessage) isValid = false;
        }



        if (nextErrors.maxNoBatteryConnection.dirty && (field ? field === "maxNoBatteryConnection" : true)) {
            const maxNoBatteryConnectionMessage = maxNoBatteryConnectionPowerValidator(maxNoBatteryConnection, form);
            nextErrors.maxNoBatteryConnection.error = !!maxNoBatteryConnectionMessage;
            nextErrors.maxNoBatteryConnection.message = maxNoBatteryConnectionMessage;
            if (!!maxNoBatteryConnectionMessage) isValid = false;
        }


        if (nextErrors.price.dirty && (field ? field === "price" : true)) {
            const priceMessage = priceValidator(price, form);
            nextErrors.price.error = !!priceMessage;
            nextErrors.price.message = priceMessage;
            if (!!priceMessage) isValid = false;
        }


        if (nextErrors.ip.dirty && (field ? field === "ip" : true)) {
            const ipMessage = ipValidator(ip, form);
            nextErrors.ip.error = !!ipMessage;
            nextErrors.ip.message = ipMessage;
            if (!!ipMessage) isValid = false;
        }
        if (nextErrors.power.dirty && (field ? field === "power" : true)) {
            const powerMessage = powerValidator(power, form);
            nextErrors.power.error = !!powerMessage;
            nextErrors.power.message = powerMessage;
            if (!!powerMessage) isValid = false;
        }
        if (nextErrors.weight.dirty && (field ? field === "weight" : true)) {
            const weightMessage = weightValidator(weight, form);
            nextErrors.weight.error = !!weightMessage;
            nextErrors.weight.message = weightMessage;
            if (!!weightMessage) isValid = false;
        }

        if (nextErrors.dimentions.dirty && (field ? field === "dimentions" : true)) {
            const dimentionsMessage = dimentionValidator(dimentions, form);
            nextErrors.dimentions.error = !!dimentionsMessage;
            nextErrors.dimentions.message = dimentionsMessage;
            if (!!dimentionsMessage) isValid = false;
        }

        console.log("isValid", isValid

        )
        setErrors(nextErrors);
        return {
            isValid,
            errors: nextErrors,
        };
    };

    const onBlurField = e => {
        const field = e.target.name;
        const fieldError = errors[field];
        if (fieldError.dirty) return;

        const updatedErrors = {
            ...errors,
            [field]: {
                ...errors[field],
                dirty: true,
            },
        };

        validateForm({ form, field, errors: updatedErrors });
    };

    return {
        validateForm,
        onBlurField,
        errors,
    };
};